<script>
/* update */
import { editorState } from "@app/store/editorStore.svelte.js";
import { eventGroupState, isSelectedEventGroupLocked } from "@app/store/eventGroupStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { commitHistory } from "@app/store/historyStore.svelte.js";
import insertEvent from "@cclib/functions/eventGroups/insertEvent.js";
import splitQuillHtml from "@cclib/functions/quill/splitQuillHtml.js";
import { current } from "immer";
import { toast } from "@zerodevx/svelte-toast";
import * as m from '@app/paraglide/messages.js';

let isDisabled = $derived(!eventGroupState[projectState.selected] ||
    eventGroupState[projectState.selected].selected.length !== 1 ||
    isSelectedEventGroupLocked());

const splitEvent = function () {
    try {
        if (isSelectedEventGroupLocked()) {
            toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
            return;
        }

        const quill = window?.quillEditor;
        let range = quill?.getSelection();
        let length = quill?.getLength();
        let frameGap = 0;

        if (
            range &&
            length &&
            range.index < length - 1 &&
            eventGroupState[projectState.selected].selected.length > 0
        ) {
            const egIdx = projectState.selected;
            const selectedIdx = eventGroupState[egIdx].selected[0];
            let start = eventGroupState[egIdx].events[selectedIdx].start;
            let end = eventGroupState[egIdx].events[selectedIdx].end;

            let duration = end - start;
            let newEventEnd = start + duration / 2;

            if (editorState.minFrameGap > 0) {
                frameGap = editorState.minFrameGap / projectState.frameRate;
            }

            /* Split the event without Quill user mutations (avoids extra history). */
            const { firstHtml, secondHtml } = splitQuillHtml(quill, range.index);

            commitHistory({
                name: "split event",
                eventGroup: egIdx,
                mutate: {
                    eventGroupState: (draft) => {
                        draft[egIdx].events[selectedIdx].text = firstHtml;
                        draft[egIdx].events[selectedIdx].end =
                            newEventEnd - frameGap;
                        draft[egIdx] = insertEvent(
                            current(draft[egIdx]),
                            {
                                ...$state.snapshot(
                                    eventGroupState[egIdx].events[selectedIdx],
                                ),
                                text: secondHtml,
                                start: newEventEnd,
                                end: end,
                                original: "",
                            },
                            selectedIdx + 1,
                        );
                    },
                },
            });
        }
    } catch (err) {
        console.log(err, err.message);
    }
};
</script>

<li class="nav-item" role="none" title={m.split_event_label()}>
    <a
        class="nav-link"
        href="#!/"
        onclick={splitEvent}
        role="button"
        id="split-event-btn"
        aria-label={m.split_event_label()}
        class:disabled={isDisabled}
        aria-disabled={isDisabled}>
        <i class="bi bi-view-stacked" aria-hidden="true"></i>
        <i class="bi bi-chevron-expand small" aria-hidden="true"></i>
    </a>
</li>
